<template>
  <Dialog
    v-model="dialog"
    :title="$t('questions.evaluation.title')"
    :buttons="buttons"
    header-type="information"
  >
    <template #leftIcon>
      <Happy event-name="playHappyEvaluation" class="icon_56" />
    </template>
    <template #text>
      <div class="mb-4">{{ $t('questions.evaluation.text') }}</div>
      <label for="evaluationText">{{ $t('questions.evaluation.label') }}</label>
      <v-textarea
        id="evaluationText"
        v-model="evaluationText"
        flat
        solo
        auto-grow
        rows="4"
        hide-details="auto"
        :placeholder="$t('questions.evaluation.placeholder')"
      ></v-textarea>
    </template>
  </Dialog>
</template>

<script>
import evaluation from '@/mixins/evaluation';
export default {
  name: 'EvaluationDialog',
  mixins: [evaluation],
  computed: {
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'evaluation';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    },
    evaluationSending: {
      get() {
        return this.$store.state.profile.evaluation.evaluationSending;
      },
      set(value) {
        this.$store.commit('profile/evaluation/setEvaluationSending', value);
      }
    },
    evaluationSkipping: {
      get() {
        return this.$store.state.profile.evaluation.evaluationSkipping;
      },
      set(value) {
        this.$store.commit('profile/evaluation/setEvaluationSkipping', value);
      }
    },
    buttons() {
      return [
        {
          type: 'sendButton',
          props: {
            loading: this.evaluationSkipping,
            color: 'tetrary'
          },
          events: {
            click: () => {
              this.processEvaluation(true);
            }
          },
          text: this.$t('skip')
        },
        {
          type: 'sendButton',
          props: {
            loading: this.evaluationSending
          },
          events: {
            click: () => {
              this.processEvaluation();
            }
          },
          text: this.$t('send')
        }
      ];
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.$eventHub.$emit('playHappyEvaluation');
        }, 500);
      }
    }
  },
  methods: {
    async processEvaluation(isSkip = false) {
      if (isSkip) {
        this.evaluationSkipping = true;
      } else {
        this.evaluationSending = true;
      }

      try {
        await this.sendEvaluation(isSkip);
        this.dialog = false;
        this.$nextTick(() => {
          this.resetEvaluation();
        });
      } catch {
        // Error already handled in sendEvaluation (handleError + Sentry)
      } finally {
        this.evaluationSending = false;
        this.evaluationSkipping = false;
      }
    }
  }
};
</script>
